"use client";

import { useEffect } from "react";
import { ErrorState } from "@/components/site/ErrorState";

/** Route-level error boundary: the page failed, the shell (fonts, CSS) did not. */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main id="main-content">
      <ErrorState
        code="خطا"
        title="مشکلی در نمایش این صفحه پیش آمد"
        lead="لطفاً دوباره تلاش کنید. اگر مشکل ادامه داشت، با کارشناسان سیمرغ تماس بگیرید."
        reference={error.digest}
        onRetry={reset}
      />
    </main>
  );
}
